import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CmpsButtonModule } from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../../route.module';
import { CmpsUserModule } from '../../user/user.module';
import { CmpsCardModule } from '../card';
import { CmpsEvalFormModule } from '../form';

import { MainComponent } from './main.component';
import { TranslationIdMap } from './main.i18n';
import { MainRoutes } from './main.route';

@NgModule({
    declarations: [MainComponent],
    exports: [MainComponent],
    imports: [
        CmpsButtonModule,
        CmpsCardModule,
        CmpsEvalFormModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsLazyRouterModule.forChild(MainRoutes),
        CmpsUserModule,
        CommonModule,
        FormsModule,
    ],
})
export class CmpsEvalMainModule {}
